import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { UnsaveChangesEvaluation } from '../interfaces/unsave-changes-evaluation';
import { RichEditorService } from '../services/rich-editor.service';
import { inject } from '@angular/core';

export const canDeactivateGuard: CanDeactivateFn<UnsaveChangesEvaluation> = (
  component: UnsaveChangesEvaluation
): Observable<boolean> | Promise<boolean> | boolean => {
  if (!component.hasUnsaveChanges()) {
    return !component.hasUnsaveChanges();
  }

  const activeRichEditor = inject(RichEditorService);
  return new Promise<boolean>(resolve => {
    const dialogRef = activeRichEditor.openUnsaveChangeWarningModal(
      component.isInvalid()
    );

    dialogRef.instance
      .afterClosed()
      .subscribe((isConfirm: boolean | undefined) => {
        if (isConfirm) {
          activeRichEditor.extractHTML((html: string) =>
            component.saveUnsaveChanges(html)
          );
        }
        resolve(isConfirm !== undefined);
      });
  });
};
